/* eslint-disable no-unused-vars */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-business-days';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import ReactSelect from 'components/StyledSelect/react_select';
import { SCHEDULING_REASONS } from 'config/constants';
import S from './suggestions.scss';

const InstallSuggestionsButtons = ({
  position, queryStart, handleQueryStartChange, errors, loadCrews, handleSuggestionAltSub,
  handleSuggestionSubmit, overrideToCal, handleSchedulingReasonChange, suggestionDisableReason,
  schedulingReason, suggestionKey, onlyOverride, isDeliveryList, needDelivery, surfaceType,
}) => {
  const minDate = moment().add((needDelivery || surfaceType === 'Carpet') ? 1 : 0, 'days');
  const maxDate = minDate.clone().add(2, 'months');

  return (<Fragment>
    <div className={S.stdBtnsContainer}>
      {(!needDelivery || isDeliveryList) && (<div className={S.datePickerContainer}>
        <DatePicker
          label="Suggestion Search Start"
          minDate={minDate.toDate()}
          maxDate={maxDate.toDate()}
          value={queryStart}
          onChange={handleQueryStartChange}
          className={S.datePicker}
          placeholder="Select Date"
          error={errors.startDate}
        />
        <ColoredButton
          label="Search From Selected Date"
          color="blue"
          onClick={loadCrews}
        />
      </div>)}
      {(!isDeliveryList && !onlyOverride) && (<div className={S.saveBtnContainer}>
        <ReactSelect
          label="Scheduling Reason"
          className={S.schedulingReason}
          placeholder={'Select Reason'}
          onChange={handleSchedulingReasonChange}
          options={SCHEDULING_REASONS}
          value={schedulingReason}
          error={errors.schedulingReason}
          required
        />
        <ColoredButton
          className={S.mainSubmitButton}
          label="Save As Installation"
          onClick={handleSuggestionSubmit}
          disabled={!suggestionKey || !schedulingReason || !!suggestionDisableReason}
          color="green"
        />
        <ColoredButton
          label="Save As Hold"
          color="blue"
          onClick={handleSuggestionAltSub}
          disabled={!suggestionKey || !schedulingReason || !!suggestionDisableReason}
        />
      </div>)}
    </div>
    {!isDeliveryList && suggestionDisableReason && <div className={S.fieldsWarning}>
      {suggestionDisableReason}
    </div>}
    {/* We may want to re-ad buttons to flip back and forth between suggestions/calendar */}
    {/* {position !== 'Customer Care Specialist' && <div className={S.overrideBtnContainer}>
      <ColoredButton
        label="Override to Calendar"
        onClick={overrideToCal}
        color="red"
        disabled={false}
      />
    </div>} */}
  </Fragment>);
};

InstallSuggestionsButtons.defaultProps = { suggestionKey: null, schedulingReason: '', isDeliveryList: false };

InstallSuggestionsButtons.propTypes = {
  position: PropTypes.string,
  queryStart: PropTypes.string,
  handleQueryStartChange: PropTypes.func,
  errors: PropTypes.object,
  loadCrews: PropTypes.func,
  handleSchedulingReasonChange: PropTypes.func,
  handleSuggestionSubmit: PropTypes.func,
  handleSuggestionAltSub: PropTypes.func,
  overrideToCal: PropTypes.func,
  isInstall: PropTypes.bool,
  suggestionDisableReason: PropTypes.string,
  schedulingReason: PropTypes.string,
  suggestionKey: PropTypes.string,
  onlyOverride: PropTypes.bool,
  isDeliveryList: PropTypes.bool,
  needDelivery: PropTypes.bool,
  surfaceType: PropTypes.string,
};

export default InstallSuggestionsButtons;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/installSuggestionsButtons.jsx